'use client';

import parse from 'html-react-parser';
import { X } from 'lucide-react';
import { cn } from '@/app_lib/utils/utils';

interface TooltipProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: React.ReactNode;
  className?: string;
}

/**
 * Tooltip component displays a tooltip with a title, close button, and content.
 */
export function tooltip({ isOpen, onClose, title, content, className = '' }: TooltipProps) {
  if (!isOpen) {
    return null;
  }

  return (
    <div
      className={cn(
        'absolute right-0 top-full mt-2 w-80 bg-white border-t-4 border-t-blue-500 rounded shadow-lg p-2 z-10',
        className,
      )}
    >
      <div className='flex items-center justify-between mb-3 gap-2 h-11'>
        <h3
          className='text-sm font-semibold text-neutral-900'
          data-cy='ndr-tooltip-title'
        >
          {title}
        </h3>
        <button
          aria-label='Close disclosure'
          className='text-neutral-900 transition-colors p-1 cursor-pointer'
          data-cy='ndr-tooltip-close-button'
          onClick={onClose}
          type='button'
        >
          <X className='w-4 h-4' />
        </button>
      </div>
      <p
        className='text-sm text-neutral-900 font-normal leading-relaxed [&_a]:underline [&_a]:text-blue-500'
        data-cy='ndr-tooltip-content'
      >
        {typeof content === 'string' ? parse(content) : content}
      </p>
    </div>
  );
}
